<template>
  <div id="add-document">
    <path-component :paths="paths" />
    <b-container v-if="!confirmAddView" fluid>
      <b-row>
        <b-col>
          <h5 class="text-left">
            {{ viewType }}
          </h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <input-invoice-component
            :invoice-number.sync="invoiceNumber"
            :date-invoice.sync="dateInvoice"
            :can-create.sync="canCreate"
            :create-invoice="createInvoice"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input-invoice-filter-component
            v-if="getCorporationType(corporation) === 'corporation'"
            :is-hospital-selected.sync="isHospitalSelected"
            class="mt-3"
          />
          <!--          <cash-document-component-->
          <!--            v-else-->
          <!--            :hospital-input.sync="hospitalInput"-->
          <!--            :order-select-items.sync="orderSelectItems"-->
          <!--            :to-input="toInput"-->
          <!--          />-->
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <add-document-table
            v-if="getCorporationType(corporation) === 'corporation'"
            :order-select-items.sync="orderSelectItems"
            :is-hospital-selected.sync="isHospitalSelected"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <add-document-footer
            v-if="getCorporationType(corporation) === 'corporation'"
          />
        </b-col>
      </b-row>
    </b-container>
    <confirm-add-document
      v-else
      :numbers.sync="numberList"
      :hospital="orderSelectItems[0].hospital_name"
      :submit="handleOk"
      :close="hideCancelModal"
      :date-invoice="dateInvoice"
      :invoice-number="invoiceNumber"
      :orders.sync="carts"
      :corporation-type="getCorporationType(corporation)"
      :is-create-view="isCreateView"
      :documents="afterCreate"
      fluid
    />
    <b-modal
      id="confirmAddDocumentModal"
      ref="confirmAddDocumentModal"
      centered
      title="ยืนยันการสร้างเอกสาร"
      ok-variant="success"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      size="lg"
      @ok="handleOk"
    >
      <confirm-add-document-modal
        v-if="orderSelectItems.length > 0"
        :numbers.sync="numberList"
        :hospital="orderSelectItems[0].hospital_name"
        :submit="handleOk"
        :close="hideCancelModal"
        :date-invoice="dateInvoice"
        :invoice-number="invoiceNumber"
        :orders="orderSelectItems"
        :corporation-type="getCorporationType(corporation)"
      />
    </b-modal>
  </div>
</template>

<script>
import PathComponent from "../../components/PathComponent";
import InputInvoiceComponent from "../../components/Account/InputInvoiceComponent";
import InputInvoiceFilterComponent from "../../components/Account/InputInvoiceFilterComponent";
import AddDocumentTable from "../../components/Account/AddDocumentTable";
import AddDocumentFooter from "../../components/Account/AddDocumentFooter";
import ConfirmAddDocumentModal from "../../components/Account/ConfirmAddDocumentModal";
// import CashDocumentComponent from "../../components/Account/CashDocumentComponent";
import ConfirmAddDocument from "../../views/Account/ConfirmAddDocument";
import moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AddDocument",
  components: {
    PathComponent,
    InputInvoiceComponent,
    InputInvoiceFilterComponent,
    AddDocumentTable,
    AddDocumentFooter,
    ConfirmAddDocumentModal,
    // CashDocumentComponent,
    ConfirmAddDocument,
  },
  props: {
    viewType: {
      type: String,
      default: "สร้างเอกสาร",
    },
  },
  data() {
    return {
      paths: [],
      invoiceNumber: "000000",
      dateInvoice: null,
      isHospitalSelected: false,
      orderSelectItems: [],
      toInput: null,
      canCreate: false,
      filterDocumentType: [],
      numberList: [],
      hospitalInput: {
        hospitalName: "",
        hospitalAddress: "",
        hospitalPhoneNumber: "",
      },
      confirmAddView: false,
      isCreateView: false,
      afterCreate: [],
    };
  },
  computed: {
    ...mapGetters({
      corporation: "Account/getCorporationSelected",
      corporations: "Account/getPlatforms",
    }),
    carts: {
      get() {
        return this.$store.state.Account.carts;
      },
      set(val) {
        this.$store.commit("Account/SET_CARTS", val);
      },
    },
  },

  watch: {
    invoiceNumber(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.canCreate =
          newVal !== "" &&
          this.dateInvoice !== "" &&
          this.orderSelectItems.length > 0;

        if (this.canCreate) {
          if (this.getCorporationType(this.corporation) === "other") {
            this.canCreate =
              this.hospitalInput.hospitalAddress !== "" &&
              this.hospitalInput.hospitalName !== "" &&
              this.hospitalInput.hospitalPhoneNumber !== "";
          }
        }
      }
    },
    dateInvoice(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.canCreate =
          newVal !== "" &&
          this.invoiceNumber !== "" &&
          this.orderSelectItems.length > 0;
        if (this.canCreate) {
          if (this.getCorporationType(this.corporation) === "other") {
            this.canCreate =
              this.hospitalInput.hospitalAddress !== "" &&
              this.hospitalInput.hospitalName !== "" &&
              this.hospitalInput.hospitalPhoneNumber !== "";
          }
        }
      }
    },
    orderSelectItems(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.canCreate =
          newVal.length > 0 &&
          this.dateInvoice !== "" &&
          this.invoiceNumber !== "";
        if (this.canCreate) {
          if (this.getCorporationType(this.corporation) === "other") {
            this.canCreate =
              this.hospitalInput.hospitalAddress !== "" &&
              this.hospitalInput.hospitalName !== "" &&
              this.hospitalInput.hospitalPhoneNumber !== "";
          }
        }
      }
    },
    hospitalInput(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.canCreate =
          this.orderSelectItems.length > 0 &&
          this.dateInvoice !== "" &&
          this.invoiceNumber !== "";
        if (this.canCreate) {
          if (this.getCorporationType(this.corporation) === "other") {
            this.canCreate =
              newVal.hospitalAddress !== "" &&
              newVal.hospitalName !== "" &&
              newVal.hospitalPhoneNumber !== "";
          }
        }
      }
    },
  },
  created() {
    this.paths = [
      {
        name: `ออกรายงาน ${this.corporation}`,
        path: "account",
        active: false,
      },
      {
        name: this.viewType,
        path: "account-add-document",
        active: true,
      },
    ];
  },
  async mounted() {
    this.isCreateView = false;
    this.invoiceNumber = await this.generateIn();
    this.dateInvoice = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
  },
  methods: {
    ...mapActions({
      generateIn: "Account/generateIn",
      createDocument: "Account/createDocument",
    }),
    createInvoice() {
      // this.$refs.confirmAddDocumentModal.show();
      this.carts = [];

      this.confirmAddView = true;

      this.orderSelectItems.forEach((order) => {
        let createdDate = order.created_at;
        let orderId = order.id;
        let animalId = order.animal_id;
        let hospitalId = order.hospital_id;
        let ln = order.ln;
        let animalName = order.animal_name;
        let speciesName = order.species_name;
        let latestApprove = order.latest_approve;

        order.test_order.forEach((test) => {
          this.carts.push({
            created_at: createdDate,
            id: orderId,
            animal_id: animalId,
            hospital_id: hospitalId,
            ln: ln,
            patient: animalName,
            spp: speciesName,
            test_item: test.test.abbreviation,
            price: test.test.price,
            quantity: 1, // NOTE:: default
            total_price: test.test.price,
            latest_approve: latestApprove,
            approver_id: latestApprove.user.id,
            test_id: test.test_id,
          });
        });
      });
    },
    async handleOk() {
      this.carts.forEach((item) => {
        item.total_price = item.price * item.quantity;
      });

      let payload = {
        date: this.dateInvoice,
        numberList: this.numberList,
        orderSelectItems: this.orderSelectItems,
        carts: this.carts,
        corporationId: this.getCorporationId(this.corporation),
        platformType: this.getCorporationType(this.corporation),
        hospitalInput: this.hospitalInput,
        to: this.toInput,
        dueDate: this.dateInvoice, //TODO:: change to real dua date
      };
      let res = await this.createDocument(payload);
      if (res) {
        // this.$router.push({
        //     name: "account",
        //     params: {
        //         afterCreate: res
        //     }
        // });
        this.afterCreate = res;
        this.isCreateView = true;
      }
    },
    hideCancelModal() {
      // this.$refs.confirmAddDocumentModal.hide();
      this.confirmAddView = false;
      this.carts = [];
    },
    getCorporationType(name) {
      return this.corporations.find(function(corporation) {
        return name === corporation.name;
      }).platform_type;
    },
    getCorporationId(name) {
      return this.corporations.find(function(corporation) {
        return name === corporation.name;
      }).id;
    },
  },
};
</script>
